import React, { useEffect, useState } from "react";
import { getRequest } from "services/api";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";

const getPayloadData = (response) => response?.data?.data || response?.data || {};

const GuideHistoryPage = ({ initialData, onError }) => {
  const [guideDetail, setGuideDetail] = useState(initialData || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationMeta, setPaginationMeta] = useState(null);

  useEffect(() => {
    const fetchGuideDetail = async () => {
      if (!initialData?.id) return;

      setLoading(true);
      setError("");
      try {
        const response = await getRequest(`/guide/${initialData.id}?include=reservations&reservations_page=${currentPage}&reservations_limit=10`);
        if (response.success) {
          setGuideDetail(getPayloadData(response));
          setPaginationMeta(response?.meta?.reservations_pagination || response?.data?.meta?.reservations_pagination || null);
        } else {
          const message = response.message || "Failed to fetch guide detail";
          setError(message);
          onError?.(message);
        }
      } catch (requestError) {
        const message = requestError.message || "Failed to fetch guide detail";
        setError(message);
        onError?.(message);
      } finally {
        setLoading(false);
      }
    };

    fetchGuideDetail();
  }, [initialData?.id, currentPage, onError]);

  const logGuides = guideDetail?.reservations || [];
  const totalPages = paginationMeta?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage,
    onPageChange: setCurrentPage,
    visiblePages: 5,
  });

  // console.log("GuideHistoryPage logGuide:", logGuide);
  // const formattedPrice = (price) => {
  //   return new Intl.NumberFormat("id-ID", {
  //     style: "currency",
  //     currency: "IDR",
  //     minimumFractionDigits: 0,
  //     maximumFractionDigits: 0,
  //   }).format(price);
  // };

  return (
    <div className="mx-auto">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Guide Detail : {guideDetail?.name || initialData?.name} </h2>

      {loading && (
        <div className="text-center py-4">
          <div className="spinner-border spinner-border-sm me-2" role="status" />
          Loading guide detail...
        </div>
      )}

      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && <div className="overflow-x-auto">
        <div className="py-2 inline-block min-w-full">
          <div className="shadow table table-responsive overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Code
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Track
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {logGuides.length > 0 ? logGuides.map((log) => (
                  <tr key={log.created_at}>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {log.reservation_date}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">{log.code}</td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {log.status}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {/* {formattedPrice(log.price_product_activities)} */}
                      {log.track}
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td className="px-4 py-4 text-center text-muted" colSpan="4">
                      No guide detail found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {paginationMeta && totalPages > 1 && (
            <div className="mt-4">
              {Pagination}
            </div>
          )}
        </div>
      </div>}
    </div>
  );
};

export default GuideHistoryPage;
